import { render, staticRenderFns } from "./NavManager.vue?vue&type=template&id=5c8a28be&scoped=true&"
import script from "./NavManager.vue?vue&type=script&lang=js&"
export * from "./NavManager.vue?vue&type=script&lang=js&"
import style0 from "./NavManager.vue?vue&type=style&index=0&id=5c8a28be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a28be",
  null
  
)

component.options.__file = "NavManager.vue"
export default component.exports